import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=8c3f7d96&scoped=true"
import script from "./CouponDetail.vue?vue&type=script&lang=js"
export * from "./CouponDetail.vue?vue&type=script&lang=js"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&id=8c3f7d96&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3f7d96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c3f7d96')) {
      api.createRecord('8c3f7d96', component.options)
    } else {
      api.reload('8c3f7d96', component.options)
    }
    module.hot.accept("./CouponDetail.vue?vue&type=template&id=8c3f7d96&scoped=true", function () {
      api.rerender('8c3f7d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/CouponDetail.vue"
export default component.exports